module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0123.jpg?v=fe56fa0c";